import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../api.js";
import { toast, ToastContainer } from "react-toastify";

const SignUp = () => {
  const navigate = useNavigate();
  const notify = () => toast("Username or Email Already Exists");
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await apiClient.post("auth/signup", formData);

      if (res.data === "User created successfully") {
        navigate("/sign-in");
      }
    } catch (error) {
      notify();
    }
  };

  return (
    <>
      <section className="sign-up-section">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="sign-up-div">
                <h1 className="sign-up-txt mt-3">Sign Up</h1>
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    className="usernameinput"
                    placeholder="Username"
                    id="username"
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    className="usernameinput mt-3"
                    placeholder="Email"
                    id="email"
                    onChange={handleChange}
                  />
                  <input
                    type="password"
                    className="usernameinput mt-3"
                    placeholder="Password"
                    id="password"
                    onChange={handleChange}
                  />
                  <button className="sing-up-btn mt-3">SIGN UP</button>
                </form>
                <p className="have-account-txt mt-3">
                  Have an account? <Link to="/sign-in">Sign In</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </section>
    </>
  );
};

export default SignUp;
